import { useState } from 'react';

import { Modal, Box, Typography, TextField, Button, CircularProgress, Grid } from '@mui/material';
import { styled } from '@mui/system';

const ModalBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '600px',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  boxShadow: 24,
  padding: theme.spacing(3),
}));

const TitleText = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '24px',
}));

const SubTitleText = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(3),
}));

const ActionButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%',
  textTransform: 'none',
}));

export const NewDomainModal = ({ userName, serverName, useHook, open, onClose }) => {
  const [isValid, setIsValid] = useState(false);

  const {
    handleCheckDomain,
    handlePurchaseDomain,
    domain,
    setDomain,
    checking,
    cost,
    error,
    step,
    setStep,
    setCost,
    setError,
    purchaseLoading,
  } = useHook({
    onClose,
    userName,
    serverName,
  });

  const handleChange = (e) => {
    const domainValue = e.target.value;

    if (domainValue.length > 70) {
      setIsValid(false);
      setError('Домен не должен превышать 70 символов');
    } else if (!/^[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/.test(domainValue)) {
      setIsValid(false);
      setError('Некорректное название домена');
    } else {
      setIsValid(true);
      setError('');
    }

    setDomain(domainValue);
  };

  const handleClose = () => {
    setDomain('');
    setCost(null);
    setError('');
    setStep(1);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalBox>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <TitleText>Новый домен для {serverName}</TitleText>
          {step !== 1 && (
            <Button onClick={() => setStep(1)} variant='outlined' size='small' disabled={purchaseLoading}>
              Назад
            </Button>
          )}
        </Box>

        {step === 1 && (
          <>
            <TextField
              autoFocus
              margin='dense'
              id='domain'
              label='Название домена'
              type='text'
              fullWidth
              variant='outlined'
              value={domain}
              onChange={handleChange}
              error={!!error}
              helperText={error}
            />
            {checking && (
              <Box display='flex' justifyContent='center' mt={2}>
                <CircularProgress />
              </Box>
            )}
          </>
        )}
        {step === 2 && (
          <>
            <SubTitleText>
              Домен <strong>{domain}</strong> доступен для регистрации.
            </SubTitleText>
            <Typography variant='body1' sx={{ mb: 2 }}>
              Стоимость регистрации ≈{' '}
              <strong>
                {cost.value} {cost.currency} / {cost.duration} {cost.durationType}
              </strong>
            </Typography>
            {purchaseLoading && (
              <Box display='flex' justifyContent='center' mt={2}>
                <CircularProgress />
              </Box>
            )}
            {error && (
              <Typography variant='body2' color='error' sx={{ mt: 1 }}>
                {error}
              </Typography>
            )}
          </>
        )}

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <ActionButton onClick={handleClose} variant='outlined' color='secondary' disabled={purchaseLoading}>
              Отмена
            </ActionButton>
          </Grid>
          <Grid item xs={12} sm={6}>
            {step === 1 && (
              <ActionButton
                onClick={handleCheckDomain}
                variant='contained'
                color='primary'
                disabled={checking || !domain || !isValid}
              >
                Проверить
              </ActionButton>
            )}
            {step === 2 && (
              <ActionButton
                onClick={handlePurchaseDomain}
                variant='contained'
                color='secondary'
                disabled={checking || !isValid || purchaseLoading}
              >
                Купить
              </ActionButton>
            )}
          </Grid>
        </Grid>
      </ModalBox>
    </Modal>
  );
};
